module.exports = __webpack_public_path__ + "static/og-logo_company-4c124fd2cb61368946906bf521be0d40.jpg";